import LearnApp from '../containers/Learn/LearnApp';
import LearnAppWithDeepLink from '../containers/Learn/LearnAppWithDeepLink';
import LearnTutorialPage from '../containers/Learn/LearnTutorialPage';
import LearnForYouPage from '../containers/Learn/LearnForYouPage';
import LearnCompletedTutorialsPage from '../containers/Learn/LearnCompletedTutorialsPage';
import {DISCOVER_TAB} from '../components/LeftNav/constants';

export const LearnRoutes = [
	{
		...LearnApp,
		path: '/learn/app',
		exact: true,
		tab: DISCOVER_TAB,
		titleId: 'app.document.title.learn',
	},
	{
		...LearnAppWithDeepLink,
		path: '/learn/app/:appName',
		exact: true,
		tab: DISCOVER_TAB,
		titleId: 'app.document.title.learn',
	},
	{
		...LearnForYouPage,
		path: '/learn/you',
		exact: true,
		tab: DISCOVER_TAB,
		titleId: 'app.document.title.learn',
	},
	{
		...LearnCompletedTutorialsPage,
		path: '/learn/completed',
		exact: true,
		tab: DISCOVER_TAB,
		titleId: 'app.document.title.learn',
	},
	{
		...LearnTutorialPage,
		path: '/learn/:app/:level/:field/:playlist/:tutorial',
		tab: DISCOVER_TAB,
		titleId: 'app.document.title.learn',
	},
	{
		...LearnTutorialPage,
		path: '/learn/:app/:level/:field/:playlist/',
		tab: DISCOVER_TAB,
		titleId: 'app.document.title.learn',
	},
];
